import { render, staticRenderFns } from "./completeness-check-modal-details-table-cell.vue?vue&type=template&id=61589cc1"
import script from "./completeness-check-modal-details-table-cell.vue?vue&type=script&lang=ts"
export * from "./completeness-check-modal-details-table-cell.vue?vue&type=script&lang=ts"
import style0 from "./completeness-check-modal-details-table-cell.vue?vue&type=style&index=0&id=61589cc1&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61589cc1')) {
      api.createRecord('61589cc1', component.options)
    } else {
      api.reload('61589cc1', component.options)
    }
    module.hot.accept("./completeness-check-modal-details-table-cell.vue?vue&type=template&id=61589cc1", function () {
      api.rerender('61589cc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/completeness-check/completeness-check-details-modal/completeness-check-modal-details-tab/completeness-check-modal-details-table-cell/completeness-check-modal-details-table-cell.vue"
export default component.exports